import apis from "../../core/apis.js";

class CityResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  search(query = "") {
    return this.$resource(apis.city + "autocomplete/").get({ query });
  }

  downloadPolygon(id, params) {
    return this.$resource(apis.city + id + "/download_kml").get(params);
  }

  getAll(options) {
    return this.$resource(apis.city).get(options);
  }

  get(id, params) {
    return this.$resource(apis.city + id).get(params);
  }

  post(item) {
    return this.$resource(apis.city).save(item);
  }
  update(id, item) {
    return this.$resource(apis.city + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  updateCategory(id, categoryId, item, method) {
    return this.$resource(
      `${apis.city}${id}/category/${categoryId}/${method}`,
      null,
      { update: { method: "PUT" } }
    ).update(item);
  }
  updateDispatcherConfiguration(id, categoryId, item) {
    return this.$resource(
      `${apis.city}${id}/category/${categoryId}/dispatcher_config`,
      null,
      { update: { method: "PUT" } }
    ).update(item);
  }
  updateAutoSkipStationConfiguration(id, categoryId, item) {
    return this.$resource(
      `${apis.city}${id}/category/${categoryId}/auto_skip_station_config`,
      null,
      { update: { method: "PUT" } }
    ).update(item);
  }
  updateWaitingTimeConfiguration(id, categoryId, item) {
    return this.$resource(
      `${apis.city}${id}/category/${categoryId}/waiting_time`,
      null,
      { update: { method: "PUT" } }
    ).update(item);
  }
  updateVariablePlanMaxThreshold(id, item) {
    return this.$resource(
      apis.city + id + "/update_supply_finances_config",
      null,
      { update: { method: "PATCH" } }
    ).update(item);
  }

  updateDistanceThreshold(id, item) {
    return this.$resource(apis.city + id + "/update_distance_threshold", null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  updateAction(id, name, item) {
    return this.$resource(apis.city + id + `/${name}`).save(item);
  }

  patchAction(id, name, item) {
    return this.$resource(apis.city + id + `/${name}`, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  putAction(id, name, item) {
    return this.$resource(apis.city + id + `/${name}`, null, {
      update: { method: "PUT" },
    }).update(item);
  }

  getRideCategory(params) {
    return this.$resource(apis.rideCategory).get(params);
  }

  getAppliedPaymentMethods(id, params) {
    return this.$resource(apis.city + id + "/applied_payment_methods").query(
      params
    );
  }

  getApplicablePaymentMethods(id, params) {
    return this.$resource(apis.city + id + "/applicable_payment_methods").query(
      params
    );
  }

  updatePaymentMethods(id, item) {
    return this.$resource(apis.city + id + "/payment_methods", null, {
      update: { method: "PATCH", isArray: true },
    }).update(item);
  }

  getCaptainVerification(id) {
    return this.$resource(apis.city + id + "/verification_headers").get();
  }

  getHexStatus(id) {
    return this.$resource(apis.city + id + "/hex_generations/status").get();
  }

  getOtherPaymentServiceOptions(id) {
    return this.$resource(
      apis.city + id + "/available_payment_service_options"
    ).query();
  }

  updateOtherPaymentServiceOptions(id, item) {
    return this.$resource(
      apis.city + id + "/update_payment_service_options"
    ).save(item);
  }
}

export default CityResource;



// WEBPACK FOOTER //
// ./src/resources/city/city.resource.js